import type { ReactElement } from "react"
import { CardTemplate } from ".."
import type { Chapter } from "../../../redux"
import { Body1 } from "../../atoms"
import { CardThumbnail as ThumbnailCard } from "../../atoms/card-thumbnail/card-thumbnail.component"

import "./chapter-card.styles.scss"

export interface IChapterCardProps {
  chapter: Chapter
  onNavigate?: (chapter: Chapter) => void
}

export function ChapterCard(props: IChapterCardProps): ReactElement {
  const { chapter, onNavigate } = props

  function navigateToChapter(): void {
    if (onNavigate) {
      onNavigate(chapter)
    }
  }

  return (
    <CardTemplate
      onClick={navigateToChapter}
      image={<ThumbnailCard image={chapter.thumbnailUrl} />}
      big
      className="chapter-card"
    >
      <Body1>{chapter.name}</Body1>
    </CardTemplate>
  )
}
